__turbopack_context__.v({
  "checkbox": "iXyh3G_checkbox",
  "content": "iXyh3G_content",
  "delimiter": "iXyh3G_delimiter",
  "dropzoneIcon": "iXyh3G_dropzoneIcon",
  "footer": "iXyh3G_footer",
  "header": "iXyh3G_header",
  "hidden": "iXyh3G_hidden",
  "image": "iXyh3G_image",
  "isFund": "iXyh3G_isFund",
  "root": "iXyh3G_root",
  "subLabel": "iXyh3G_subLabel",
  "subheader": "iXyh3G_subheader",
  "teamNameSection": "iXyh3G_teamNameSection",
});
